export default __webpack_public_path__ + "52d61def9895dc17c599ff67832834dc.svg";